import { render } from "./ClasificationCreatePage.vue?vue&type=template&id=fa748714"
import script from "./ClasificationCreatePage.vue?vue&type=script&lang=js"
export * from "./ClasificationCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__